import axios from "axios";

export const state = {
    exammarks: [],
};

export const getters = {
    exammarks: state => state.exammarks,
};

export const mutations = {
    setMarksEntry(state, newValue) {
        state.exammarks = newValue
    },
};
 
export const actions = {
    fetchExamMarks({commit}, {schoolterm,year,schoolclass,user,exam,subject}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        formData.append("user", user);
        formData.append("exam", exam);
        formData.append("subject", subject);
        let url = "/addexammarks";
        axios.post(url, formData).then((response) => {
            commit('setMarksEntry', response.data.marks)
        })
    },
};
